const attachmentFilesEquipmentModelsBtn = {
  label: 'AGREGAR'
};

export default attachmentFilesEquipmentModelsBtn;
